module.exports = __webpack_public_path__ + "static/media/invitatie-video-icon.d20f4be1.svg";